import { useLocation, useNavigate } from "react-router-dom";
import { getDefaultParameters } from "./../../../utils/getDefaultParams";

export interface onNavigateProps {
    path?: string;
    params?: Record<string, unknown>;
    state?: Record<string, unknown>;
    replace?: boolean;
}

export const useNewNavigate = () => {
    const navigate = useNavigate();
    const { pathname, state } = useLocation();
    const mainPath = pathname.split("/")[1];

    const onNavigate = ({ path, params, state, replace }: onNavigateProps) => {
        const co_id = getDefaultParameters().co_id;
        const mergedParams = { co_id, ...params };
        const searchParams = new URLSearchParams(mergedParams);

        navigate(`${path ?? ""}?${searchParams?.toString()}`, { state: state, replace: replace ? replace : false });
    };

    return { onNavigate, mainPath, state };
};
